/* global sessionStorage */
import $ from 'jquery';
import { emitter } from './utils/custom-events.js';
import config from './config.js';
import Cookies from './libs/tomcat-cookies.js';
import floatingLabels from './floating-labels.js';
import notifications from './notifications.js';
import spinner from './spinner.js';
import togglePassword from './toggle-password.js';
import ingame from './casino/ingame.js';
import sportsHelper from './sportsbook/sports-helper.js';
import websocket from './websocket/websocket-event-esm.js';
import {
	navigation,
	sessionKey,
	lastProduct,
	setNavigationCookies,
	setDesktopCookies,
	rootDomain
} from './store/cookies.js';
import { push, basePathname, replace, history } from './store/history.js';
import { eventType } from './config/settings.js';
import forgottenPassword from './forgotten-password.js';
import { fetchJson } from './core/ajax-json.js';
import menuesRootview from './menues_rootview.js';
import currencyFormatter from './libs/currency-formatter.js';
import { getLocale } from './libs/locale.js';

const $login = $('.log-in');
const $loginForm = $login.find('form');
const $termsForm = $('.terms-menu').find('.u-btn-wrapper');
const $allGamesTab = $('#section2');
const $allGamesGrid = $allGamesTab.find('.game-grid');
const $supportNav = $('.support-nav');
const $bottomWrapper = $login.parent();
// const $notificationWrapper = $('.terms-menu');
const ERROR_CLASS = 'input-wrap__error';
const VALID_CLASS = 'is-valid';
let isInited = false;
let shouldShowCompliance = false;

function setLoginClass(state) {
	const root = document.documentElement;
	const status = state !== undefined ? state : sessionKey();
	if (status) {
		root.classList.add('is-logged-in');
		root.classList.remove('is-not-logged-in');
	} else {
		root.classList.add('is-not-logged-in');
		root.classList.remove('is-logged-in');
	}
}

setLoginClass();
function changeBalanceSportsbook(balance) {
	if (navigation() === 'sportsbook') {
		$('#casino-header-title').text(balance);
	}
}

function emptyBalanceSportsbook() {
	if (navigation() === 'sportsbook') {
		$('#casino-header-title').text('');
	}
}

function setLoggedOutStyle() {
	$('.header-icon--login').removeClass('u-hide').addClass('u-show');
	$('.header-icon--account').removeClass('u-show').addClass('u-hide');
	$('.bottom-wrapper').removeClass('log-in--loggedin');
	$login.addClass('log-in--is-not');

	setLoginClass(false);

	closeAllWindows();
}

function closeAllWindows() {
	menuesRootview.closeMySettings();
	$('#js-deposit-flow').removeClass('deposit--open');
}

// Logout
function simpleLogout(message) {
	// var loginBtn = $loginForm.find('.login-in-button');
	const loggedOutMsg = message.message;
	notifications.showNotification(loggedOutMsg, 'red', true);

	logoutSetUp();
	emptyBalanceSportsbook();

	if (location.href.includes('shop')) {
		location.reload();
	}
}

websocket.on('player.logout', (event, message) => {
	console.info(event, message);
    if (typeof message.webSessionIdToKeep === 'undefined' || message.webSessionIdToKeep !== sessionKey()) {
		websocket.disconnect();
		simpleLogout(message);
    }
});

websocket.on('player.update', (event, message) => {
	if (navigation() === 'sportsbook') {
		console.info(event, message);
		fetchJson('/player/currency')
			.then((response) => {
				const formattedBalance = currencyFormatter.format(message.totalBalance, response.result, getLocale());
				changeBalanceSportsbook(formattedBalance);
			});
	}
});

function closeSupportNavIfOpen() {
	$supportNav.removeClass('support-nav--is-open');
}

function openLoginFrom(gameCode) {
	init();
	closeSupportNavIfOpen();
	$login.removeClass('u-hide').addClass('u-show');
	$bottomWrapper.addClass('log-in--open');
	$login.removeClass('log-in--is-not');

	setTimeout(() => {
		$bottomWrapper.addClass('u-transform-none u-absolute u-pos-t0');
	}, 750);

	if (gameCode) {
		$login.find('.login-in-button').attr('loadGame', gameCode);
	}
}

function changeHeaderIcon() {
	$('.header-icon--login').removeClass('u-show').addClass('u-hide');
	$('.header-icon--account').removeClass('u-hide logged-out').addClass('u-show');
	$bottomWrapper.addClass('log-in--loggedin');
}

function closeLoginForm() {
	$bottomWrapper.removeClass('menu--is-open log-in--open');
	$login.addClass('log-in--is-not');
	$bottomWrapper.removeClass('log-in--open u-transform-none u-absolute u-pos-t0');
	$loginForm.find('.login-in-button').removeClass('btn--is-loading');
}

function doLogin($game, termsAccepted) {
	/* After each login the getPlayerInfo, getPlayerBalance and getPlayerPoints are called. */
	const $email = $loginForm.find("input[id='login-email']");

	const $pass = $loginForm.find("input[id='login-password']");

	const data = {
		email: $email.val(),
		password: $pass.val(),
		isComplianceTermsAccepted: false
	};

	if (termsAccepted) {
		data.isComplianceTermsAccepted = true;
	}

	$.ajax({
		url: '/player/session/login',
		method: 'POST',
		data: JSON.stringify(data),
		contentType: 'application/json; charset=utf-8'
	}).done((resultData) => {
			let dmain = null; // temp while dev.
			if (resultData.status === 'SUCCESS') {
				Cookies.set('reality-check-login', true);
				emitter.emit('login');
				Cookies.set('login', true);
				const newSessionKey = resultData.result.sessionKey;
				notifications.hideNotification();
				changeHeaderIcon();
				dmain = rootDomain();
				Cookies.set('sessionId', newSessionKey, {domain: rootDomain()});
				Cookies.set('loginEmail', data.email);
				console.info('login:sessionId:', newSessionKey);
				console.info('login:domain', dmain);

				if ({}.hasOwnProperty.call(resultData.result, 'shouldShowComplianceMessage')) {
					shouldShowCompliance = resultData.result.shouldShowComplianceMessage;
				} else {
					console.warn('could not find compliance flag');
				}

				if (termsAccepted && !shouldShowCompliance) {
					//we replace the t&c page in the history to stop user going back to it
					//we replace t&c page with '/casino' if the user came from landing page
					//we don't want the user to go back to landing page after logging in
					let redirectUrl = (basePathname() == '/') ? '/casino' : basePathname();
					replace(redirectUrl);
				}

				if (shouldShowCompliance) {
					push('/terms_and_conditions');
					notifications.showNotification(resultData.result.complianceMessageHeader, 'green', true);
					// TODO get rid of this once notifications are sorted
					// this is to make the buttons clickable on t&c page
					$('.global-notification').addClass('is-simple-notification');
					return;
				}

				// Notify native app clients about the login action and provide the necessary credentials.
				try {
					window.webkit.messageHandlers.nativeBridgeHandler.postMessage((data.WebAction = 'Login', data));
				} catch (e) {
					console.log('Native bridge error : ', e);
				}

				// clean login form if user already accepted the T&C
				// else keep the data on loginform for use in logging user in again after accept
				// don't clear login field CO-17549
				// $loginForm.find('input[type=text], input[type=email], input[type=password]').val('');
				// remove helper classes
				$bottomWrapper.removeClass('u-transform-none u-absolute u-pos-t0');

				try {
					websocket.connect(newSessionKey);
				} catch (e) {
					console.error('Websocket error:', e);
				}

				if ($game) {
					// we don't close the login form here because this is a redirect currently.
					// loagGame gets the game object, fun mode false, callback to execute when session not longer valid
					ingame.loadGame($game, false, openLoginFrom($game));
					return;
				}


				const referrer = history.location.state.from.pathname;
				if (config.page === 'landing') {
					console.log(lastProduct());
					if (!lastProduct()) {
						getDefaultPath(() => {
							document.location.replace('/global');
						});
					} else {
						if (referrer) {
							document.location.replace(referrer);
						} else {
							getDefaultPath((path) => {
								document.location.replace(path);
							});
						}

					}
				} else if (lastProduct() === 'shop') {
					document.location.replace('/shop');
				} else if (lastProduct() === 'sportsbook') {
					if (referrer) {
						sportsHelper.fetchToken(referrer);
					} else {
						getDefaultPath((path) => {
							sportsHelper.fetchToken(path);
						});
					}
				} else {
					if (referrer) {
						document.location.replace(referrer);
					} else {
						getDefaultPath((path) => {
							document.location.replace(path);
						});
					}
				}
			}
			if (resultData.status === 'FAILURE') {
				console.error(`${resultData.errorDescription}. Code: ${resultData.errorCode}`);
				notifications.showNotification(resultData.errorDescription, 'red', true);

				if (resultData.errorDescription.includes('<a href')) {
					//TODO find a good way to validate the error textkey has an anchor tag in it and style it properly
					document.getElementsByClassName('notification-wrap__error-text-msg')[0].getElementsByTagName('a')[0].onclick = () => {
						setDesktopCookies();
						return true;
					};
				}

				$loginForm.find('.login-in-button').removeClass('btn--is-loading');
			}
			setLoginClass(true);
		}
	)
		.fail((jqXHR, textStatus, errorThrown) => {
			console.error(jqXHR, textStatus, errorThrown);
			const loginButton = document.getElementsByClassName('js-login-button');
			notifications.showNotification(loginButton[0].getAttribute('data-error-message-ajax-failure'), 'red');
			setLoginClass(false);
		})
		.always(() => {
			spinner.hide($loginForm);
			spinner.hide($termsForm);
		});
}

function getDefaultPath(cb) {
	fetchJson('/site')
		.then((response) => {
			const defaultPath = response.result.toLowerCase();
			setNavigationCookies(defaultPath);
			cb(defaultPath);
		});
}

function logoutSetUp() {
	setLoggedOutStyle();
	Cookies.remove('sessionId', {domain: rootDomain()});
	Cookies.remove('franchise', {domain: rootDomain()});
	/**
	 * Push to default product URL.
	 * @todo - only push if current view is private
	 */
	replace(basePathname());
	emitter.emit('logout');
}

function sendLogout() {
	$.ajax({
		url: '/player/session/logout',
		type: 'GET',
		contentType: 'application/json; charset=utf-8'
	}).done((resultData) => {
		if (resultData.status === 'SUCCESS') {

		}
		if (resultData.status === 'FAILURE') {
			console.log(`Failed on logout ${resultData.errorDescription}Error code: ${resultData.errorCode}`);
			notifications.showNotification(`Failed on logout ${resultData.errorDescription}`, 'red', true);
		}

		logoutSetUp();
		emptyBalanceSportsbook();

		$loginForm.find('.login-in-button').removeClass('btn--is-loading');
		if (lastProduct() === 'shop') {
			location.reload();
		}
	}).fail((jqXHR, textStatus, errorThrown) => {
		console.error(jqXHR, textStatus, errorThrown);
		logoutSetUp();
	});
}

// Logout
function doLogout() {
	// TODO add spinner
	if (sessionKey() && sessionKey() !== 'undefined') {
		sendLogout();
	} else {
		logoutSetUp();
	}
}

function checkComplianceFlag() {
	return shouldShowCompliance;
}

function displayError(field) {
	const $inputField = $(field);
	const $inputFieldParent = $inputField.parent();
	let errorMessage = $inputFieldParent.data('content-error');
	if ($inputFieldParent.data('content-dynamic-error') !== undefined) {
		errorMessage = $inputField.data('content-dynamic-error');
	}
	$inputFieldParent.find('.js-input-error-display').text(errorMessage);
}

function removeErrorMessage(field) {
	const $inputField = $(field);
	const $inputFieldParent = $inputField.parent();
	$inputFieldParent.find('.js-input-error-display').text('');
}

function markInvalid($input) {
	$input.addClass(ERROR_CLASS).removeClass(VALID_CLASS);
	displayError($input);
}

function markValid($input) {
	$input.addClass(VALID_CLASS).removeClass(ERROR_CLASS);
	removeErrorMessage($input);
}

function validateLoginForm(loginForm) {
	/* The argument is a jquery-selection, and contains jquery specific functionality. Therfore it is preceeded by '$' to denotate this.
	 'The .val() method is primarily used to get the values
	 of form elements such as input, select and textarea.  */

	// validate fields
	const $email = $(loginForm).find("input[id='login-email']");

	const $pass = $(loginForm).find("input[id='login-password']");
	let emailValid = false;
	let passValid = false;

	// TODO add real email and pass validation
	if (!$email.val()) {
		markInvalid($email);
	} else {
		markValid($email);
		emailValid = true;
	}
	if (!$pass.val()) {
		markInvalid($pass);
	} else {
		markValid($pass);
		passValid = true;
	}
	return (emailValid && passValid);
}

function setUpClickHandlers() {
	$login.find('.page-head .icon-close').on(eventType, () => {
		// var router = require('./router');
		replace(basePathname());
	});


	// submit form and do login
	$loginForm.find('.login-in-button').on(eventType, function submitLogin(event) {
		$(this).addClass('btn--is-loading'); // Hide the text on the button
		const gameToOpen = $(this).attr('loadgame');
		let $game;

		/* event.preventDefault() or 'return false' is required here, otherwise the page will redirect. */
		event.preventDefault();
		event.stopPropagation();

		if (gameToOpen) {
			$game = $allGamesGrid.find(`.game-item[data-gamecode="${gameToOpen}"]`);
		}

		if (validateLoginForm($loginForm)) {
			spinner.show($loginForm);
			doLogin($game);
		}
	});
	const loginElem = document.getElementsByClassName('log-in')[0];
	if (loginElem !== undefined) {
		forgottenPassword.init(document.getElementsByClassName('log-in')[0]);
	}


	// Logout - is handled by <a href="#/logout">... see 'router.js'
}

function init() {
	/* if already initialized it should not be possible to repeat the setup. Clickhandlers are then for example added again. */
	/* An alternative way to init is to hook up this module to an action handler. Anywhere from the application the login
	 then may be initialized without need for a strong coupling to this api
	 (see fluxpattern for more info. https://facebook.github.io/flux/) */
	if (isInited) {
		return;
	}

	floatingLabels.setupPersistentLabels($loginForm);
	togglePassword.setupInForm($loginForm);
	setUpClickHandlers();
	isInited = true;

	const loginEmail = Cookies.get('loginEmail');
	if (loginEmail) {
		$loginForm.find("input[id='login-email']").val(loginEmail);
	}
	// const sessionKey = Cookies.get('sessionId');
	if (sessionKey()) {
		websocket.connect(sessionKey());
	}
}

/**
 * Inititalize login form when it's open in openLoginFrom. Removed init from export.
 */

const loginApi = {
	doLogin,
	doLogout,
	openLoginFrom,
	closeLoginForm,
	changeHeaderIcon,
	checkComplianceFlag,
	getDefaultPath
};

export default loginApi;



// WEBPACK FOOTER //
// ./mobile-core/src/login.js